import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// CHEQUE BOOK VERIFICATION
// Legacy: /AccountsApproval/VerifyCheque (+ VerifyChequeGrid / VerifyChequeView / UpdateChequeView)
// ==============================================

const headers = { 'Content-Type': 'application/json' };

const handle = (error) => {
    if (error.response?.data) throw error.response.data;
    throw error;
};

// Queue — cheque books pending at this role's level.
export const getVerificationCheques = async (roleId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetCheque`, { params: { Roleid: roleId }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Detail of one pending cheque book (one-row list; carries MOID and the authoritative From/To range).
export const getVerificationChequeById = async (chequeId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetchqverificationbyId`, { params: { chqid: chequeId }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Detail of a returned cheque book for the resubmit form.
export const getReturnedChequeById = async (chequeId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetReturnchequebyId`, { params: { chequeid: chequeId }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Bank dropdown for the resubmit form.
export const getBanks = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetBankDetails`, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Verify / Approve / Return / Reject (spVerifyChequeno — success literal "Submitted").
export const verifyCheque = async (payload) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/Accounts/VerifyCheque`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Resubmit a returned cheque book (spChequebookReturn — success literal "Successfull").
export const updateReturnedCheque = async (payload) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/Accounts/Updatecheque`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};
